import type { OverallSupplierScore } from "../../types/meeting.type";

export const BELOW_LEADER_THRESHOLD = 0.2;

export function getLeaderInviteId(suppliers: OverallSupplierScore[]): number | null {
  let leaderId: number | null = null;
  let leaderScore: number | null = null;

  for (const supplier of suppliers) {
    const score = supplier.consensus_weighted_total ?? supplier.pre_meeting_weighted_average;
    if (score !== null && (leaderScore === null || score > leaderScore)) {
      leaderScore = score;
      leaderId = supplier.invite_id;
    }
  }

  return leaderId;
}

export function getLeaderScore(
  suppliers: OverallSupplierScore[],
  leaderId: number | null
): number | null {
  if (leaderId === null) {
    return null;
  }
  const leader = suppliers.find((s) => s.invite_id === leaderId);
  if (!leader) {
    return null;
  }
  return leader.consensus_weighted_total ?? leader.pre_meeting_weighted_average;
}

export function isBelowThreshold(
  supplier: OverallSupplierScore,
  leaderScore: number | null
): boolean {
  if (leaderScore === null || leaderScore === 0) {
    return false;
  }
  const score = supplier.consensus_weighted_total ?? supplier.pre_meeting_weighted_average;
  if (score === null) {
    return false;
  }
  return (leaderScore - score) / leaderScore > BELOW_LEADER_THRESHOLD;
}
